import Vue from 'vue'
import App from './App.vue'
import ViewUI from 'view-design'
import { request } from './api'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import axios from 'axios'
import './assets/css/index.less'
import './assets/icon/iconfont.js'
import '@/libs/viewport'
import VueI18n from 'vue-i18n'
import { session } from '@/libs/location'

// 初始化 primary-color CSS 变量（从缓存中读取）
try {
  const userInfo = JSON.parse(session.getItem('userInfo') || '{}')
  if (userInfo && userInfo.skinColor) {
    document.documentElement.style.setProperty('--primary-color', userInfo.skinColor)
  }
} catch (e) {
  console.warn('初始化主题色失败:', e)
}
import en from 'view-design/dist/locale/en-US'
import zh from 'view-design/dist/locale/zh-CN'
import tw from 'view-design/dist/locale/zh-TW'
import ko from 'view-design/dist/locale/ko-KR'
import th from 'view-design/dist/locale/th-TH'
import { Toast, Search, Popup, Icon } from 'vant'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

// 使用babel-plugin-import引入vant后，可以直接按需使用vant组件
Vue.use(Toast)
Vue.use(Search)
Vue.use(Popup)
Vue.use(Icon)
/**
 * @description 全局注册请求变量
 */
Vue.prototype.$request = request

/**
 * @description 时间处理插件
 */
Vue.prototype.$dayjs = dayjs

/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
})

const i18n = new VueI18n({
  locale: 'zh-CN', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'en-US': Object.assign(require('./assets/languages/en-US.js'), en),
    'zh-CN': Object.assign(require('./assets/languages/zh-CN.js'), zh),
    'zh-TW': Object.assign(require('./assets/languages/zh-TW.js'), tw),
    'ko-KR': Object.assign(require('./assets/languages/ko-KR.js'), ko),
    'th-TH': Object.assign(require('./assets/languages/th-TH.js'), th)
  }
})

// 本地环境配置
if (process.env.NODE_ENV === 'development') {
  const baseUrl = ''
  Vue.prototype.$baseUrl = baseUrl
  // axios 全局变量
  axios.defaults.baseURL = baseUrl

  // 全局配置参数
  const appid = 'ww8bd6fa37df85f30f'
  const agentid = '1000006'
  Vue.prototype.$appid = appid
  Vue.prototype.$agentid = agentid
} else {
  axios.get('/qc-portal/dynamicConfig.json').then(result => {
    const baseUrl = result.data.baseUrl
    console.log(baseUrl, 'baseUrl')
    Vue.prototype.$baseUrl = `${window.document.location.origin}/`
    // axios 全局变量 //
    axios.defaults.baseURL = `${window.document.location.origin}/`

    // 全局配置参数
    const appid = 'ww9a9ceb2a6312c310'
    const agentid = '1000029'
    Vue.prototype.$appid = appid
    Vue.prototype.$agentid = agentid
  }).catch((error) => {
    console.log(error)
  })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

export default i18n
